import PhotoDetails from '../src/PhotoDetails';
export default PhotoDetails;
